"use client";

import { useEffect, useState } from "react";

import { CcButton } from "@/components/ui/CcButton";

import styles from "./google-ads-consultant.module.scss";

/**
 * Phone-only booking bar. It appears once the hero buttons have scrolled away
 * and hides again while the pricing offer (which has its own button) is on
 * screen, so two booking buttons never compete.
 */
export function CcGoogleAdsConsultantStickyCta({
  copy,
  hideWhenVisible,
}: {
  copy: { cta: string; note: string };
  hideWhenVisible: string[];
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const elements = hideWhenVisible
      .map((id) => document.getElementById(id))
      .filter((element): element is HTMLElement => Boolean(element));
    if (!elements.length) return;
    const onScreen = new Set<Element>(elements);
    const heroCta = elements[0];
    let passedHero = false;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) onScreen.add(entry.target);
        else onScreen.delete(entry.target);
        if (entry.target === heroCta && !entry.isIntersecting) {
          passedHero = entry.boundingClientRect.top < 0;
        }
      }
      setVisible(passedHero && onScreen.size === 0);
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [hideWhenVisible]);

  return (
    <div className={styles.sticky} data-visible={visible ? "true" : "false"} inert={!visible}>
      <CcButton bookCallPopup bookCallVariant="sem" label={copy.cta} expand expandCompact />
      <span className={styles.stickyNote}>{copy.note}</span>
    </div>
  );
}
